module.exports = __webpack_public_path__ + "img/smart_toy.e106b4af.svg";